import { singleton } from "tsyringe";
import type { ValidFunction, Status } from "@/shared/lib/types/model";

@singleton()
export default class AgnosticValidationHandler {
    public handler(value: string, validFunctions: ValidFunction[]): Status {
        let status = { valid: true };
        validFunctions.forEach((validFunction) => {
            const Status = validFunction(value);

            if (!Status.valid) {
                status = { ...Status };
                return;
            }
        });

        return status;
    }
}
